const useToolInventory = ({ dispatch, ACTIONS }) => {
  const vehicleNumberHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_VEHICLE_NUMBER,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const vehicleTypeHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_VEHICLE_TYPE,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const trailerTypeAndNumHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_TRAILER_TYPE_AND_NUM,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const otdrMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_OTDR_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const otdrSerialHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_OTDR_SERIAL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fsMachineSingleMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FS_MACHINE_SINGLE_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fsMachineSingleSerialHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FS_MACHINE_SINGLE_SERIAL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fsMachineRibbonMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FS_MACHINE_RIBBON_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fsMachineRibbonSerialHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FS_MACHINE_RIBBON_SERIAL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fiberMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FIBER_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fiberSerialHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FIBER_SERIAL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const opticalLossMakeModel1Handler = (e) => {
    dispatch({
      type: ACTIONS.SET_OPTICAL_LOSS_MAKE_MODEL_1,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const opticalLossSerial1Handler = (e) => {
    dispatch({
      type: ACTIONS.SET_OPTICAL_LOSS_SERIAL_1,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const opticalLossMakeModel2Handler = (e) => {
    dispatch({
      type: ACTIONS.SET_OPTICAL_LOSS_MAKE_MODEL_2,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const opticalLossSerial2Handler = (e) => {
    dispatch({
      type: ACTIONS.SET_OPTICAL_LOSS_SERIAL_2,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const drillHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_DRILL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const splicingTableMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_SPLICING_TABLE_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const bufferTubeMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_BUFFER_TUBE_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const splicerTentMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_SPLICER_TENT_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fiberOpticDropSlitterHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FO_DROP_SLITTER_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const midSpanSplitterToolHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_MIDSPAN_SPLITTER_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const coreTubeEntryKitHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_CORE_TUBE_ENTRY_KIT_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const toolsetMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_TOOLSET_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const signAndHolderMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_SIGN_AND_HOLDER_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const conesMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_CONES_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const safetyVestAndHardHatMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_SAFETY_VEST_AND_HARD_HAT_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const harnessMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_HARNESS_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const fishTapeMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_FISHTAPE_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const ladder28ftMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_LADDER_28FT_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const ladder6ftMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_LADDER_6FT_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const bareFiberAdapterMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_BARE_FIBER_ADAPTER_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const exfoLaunchBagMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_EXFO_LAUNCH_BAG_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const handToolsMakeModelHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_HAND_TOOLS_MAKE_MODEL,
      value: e.target.value,
    });
    dispatch({ type: ACTIONS.SET_FORM_VALID });
  };

  const toolNotesChangeHandler = (e) => {
    dispatch({
      type: ACTIONS.SET_TOOL_NOTES,
      value: e.target.value,
    });
  };

  return {
    bareFiberAdapterMakeModelHandler,
    bufferTubeMakeModelHandler,
    conesMakeModelHandler,
    coreTubeEntryKitHandler,
    drillHandler,
    exfoLaunchBagMakeModelHandler,
    fiberMakeModelHandler,
    fiberOpticDropSlitterHandler,
    fiberSerialHandler,
    fishTapeMakeModelHandler,
    fsMachineRibbonMakeModelHandler,
    fsMachineRibbonSerialHandler,
    fsMachineSingleMakeModelHandler,
    fsMachineSingleSerialHandler,
    handToolsMakeModelHandler,
    harnessMakeModelHandler,
    ladder28ftMakeModelHandler,
    ladder6ftMakeModelHandler,
    midSpanSplitterToolHandler,
    opticalLossMakeModel1Handler,
    opticalLossMakeModel2Handler,
    opticalLossSerial1Handler,
    opticalLossSerial2Handler,
    otdrMakeModelHandler,
    otdrSerialHandler,
    safetyVestAndHardHatMakeModelHandler,
    signAndHolderMakeModelHandler,
    splicerTentMakeModelHandler,
    splicingTableMakeModelHandler,
    toolNotesChangeHandler,
    toolsetMakeModelHandler,
    trailerTypeAndNumHandler,
    vehicleNumberHandler,
    vehicleTypeHandler,
  };
};

export default useToolInventory;
